export default __webpack_public_path__ + "static/font-3424855df242bebcbba679c2e6757826.woff2";